import VInputAdministratorPhone from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputAdministratorPhone', VInputAdministratorPhone),
};
